import React from "react";
export const pickChild = (children, targetChild) => {
    const target = [];
    const withoutTargetChildren = React.Children.map(children, (item) => {
        if (!React.isValidElement(item))
            return item;
        if (item.type === targetChild) {
            target.push(item);
            return null;
        }
        return item;
    });
    const targetChildren = target.length >= 0 ? target : undefined;
    return [withoutTargetChildren, targetChildren];
};
//# sourceMappingURL=pick-child.js.map